import React from 'react';

const BS_Inputs2 = () => {
    return (
        <div>
            <h1>BS_Inputs2 Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Inputs2;
